<template>
    <div name="medicine-filter" :class="['medicine-filter', { 'medicine-filter-compact': compact }]">
        <insulin-select-modal
            v-if="isInsulinModal"
            :selected="pharmacyMedicineFilter.insulins"
            @close="closeInsulinModal"
            @change="changeInsulins"
        />

        <!-- 인슐린: 누르면 약품 선택 모달 -->
        <div
            :class="['chip', { 'chip-active': insulinCount > 0 }]"
            role="button"
            tabindex="0"
            aria-haspopup="dialog"
            @click="openInsulinModal"
            @keydown.enter.prevent="openInsulinModal"
            @keydown.space.prevent="openInsulinModal"
        >
            <span :class="['check', { 'check-active': insulinCount > 0 }]">
                <svg v-if="insulinCount > 0" width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <path d="M2.5 6.2l2.3 2.3 4.7-4.9" stroke="#FFF" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </span>
            <span>인슐린</span>
            <span v-if="insulinCount > 0" class="count">{{ insulinCount }}</span>
            <svg class="chevron" width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M3 4.5L6 7.5l3-3" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </div>

        <!-- 바크시미: 누르면 바로 체크 -->
        <div
            :class="['chip', { 'chip-active': pharmacyMedicineFilter.baqsimi }]"
            role="checkbox"
            tabindex="0"
            :aria-checked="pharmacyMedicineFilter.baqsimi ? 'true' : 'false'"
            @click="toggleBaqsimi"
            @keydown.enter.prevent="toggleBaqsimi"
            @keydown.space.prevent="toggleBaqsimi"
        >
            <span :class="['check', { 'check-active': pharmacyMedicineFilter.baqsimi }]">
                <svg v-if="pharmacyMedicineFilter.baqsimi" width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <path d="M2.5 6.2l2.3 2.3 4.7-4.9" stroke="#FFF" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </span>
            <span>바크시미</span>
        </div>
    </div>
</template>

<script>
import Constant from '@/constant';
import {mapState} from 'vuex';
import InsulinSelectModal from '@/components/modals/InsulinSelectModal';

export default {
    name: 'medicineFilter',
    components: { InsulinSelectModal },
    // compact: 지도 하단 검색 영역처럼 공간이 좁은 곳에서 작은 크기로
    props: {
        compact: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapState(['pharmacyMedicineFilter']),
        insulinCount: function()
        {
            return this.pharmacyMedicineFilter.insulins.length;
        }
    },
    data: function()
    {
        return {
            isInsulinModal: false
        }
    },
    methods: {
        openInsulinModal: function()
        {
            this.isInsulinModal = true;
        },
        closeInsulinModal: function()
        {
            this.isInsulinModal = false;
        },
        // 모달이 닫힐 때 선택이 바뀐 경우에만 호출된다
        changeInsulins: function(insulins)
        {
            this.$store.commit(Constant.SET_PHARMACY_MEDICINE_FILTER, {insulins: insulins});
        },
        toggleBaqsimi: function()
        {
            this.$store.commit(Constant.SET_PHARMACY_MEDICINE_FILTER, {baqsimi: !this.pharmacyMedicineFilter.baqsimi});
        }
    }
}
</script>

<style scoped>
    .medicine-filter {
        display: flex;
        align-items: center;
        gap: 8px;
        flex-shrink: 0;
    }
    .chip {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        height: 44px;
        padding: 0 14px 0 12px;
        box-sizing: border-box;
        border: 1px solid var(--gray-40-button-stroke, #D1D6DB);
        border-radius: 100px;
        background: var(--Gray-00, #FFF);
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px;
        cursor: pointer;
        outline: none;
        user-select: none;
        -webkit-tap-highlight-color: transparent;
        transition: border-color 0.15s, background-color 0.15s, color 0.15s;
    }
    .chip:active {
        background: var(--Gray-20, #F3F5F8);
    }
    .chip-active {
        border-color: #184FA1;
        background: #EAF1FB;
        color: #184FA1;
        font-weight: 600;
    }
    .chip-active:active {
        background: #DCE7F7;
    }
    .check {
        flex-shrink: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 18px;
        height: 18px;
        margin-right: 6px;
        box-sizing: border-box;
        border: 1.5px solid #C5CBD3;
        border-radius: 5px;
        background: var(--Gray-00, #FFF);
        transition: background-color 0.15s, border-color 0.15s;
    }
    .check-active {
        border-color: #184FA1;
        background: #184FA1;
    }
    .count {
        display: flex;
        justify-content: center;
        align-items: center;
        min-width: 20px;
        height: 20px;
        margin-left: 6px;
        padding: 0 6px;
        box-sizing: border-box;
        border-radius: 100px;
        background: #184FA1;
        color: var(--Gray-00, #FFF);
        font-size: 12px;
        font-weight: 600;
        line-height: 1;
    }
    .chevron {
        margin-left: 4px;
    }

    /* compact */
    .medicine-filter-compact .chip {
        height: 36px;
        padding: 0 12px 0 10px;
        font-size: 15px;
    }
    .medicine-filter-compact .check {
        width: 16px;
        height: 16px;
        margin-right: 5px;
        border-radius: 4px;
    }
    .medicine-filter-compact .count {
        min-width: 18px;
        height: 18px;
        padding: 0 5px;
        font-size: 11px;
    }
</style>



// WEBPACK FOOTER //
// src/components/molecules/maps/MedicineFilter.vue